// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification-header{display:flex;align-items:center;padding:6px 0 0 14px}.notification-header .title{font-size:20px;line-height:28px;padding-right:8px}.light-theme .notification-header .title{color:#636363}.dark-theme .notification-header .title{color:#a9a297}@media(max-width: 520px){.notification-header .title{font-size:16px}}", ""]);
// Exports
module.exports = exports;
